import { SelectableItem } from 'src/app/shared/components/grid-bulk-actions/grid-bulk-actions.component';
import { AvailableDataColumn } from '../../models/grid';

export interface SelectableJob extends SelectableItem {
    activeFlag: boolean | null;
    ingestionId: number | null;
    ingestMode: string | null;
    batchSize: number | null;
    watermarkKey: string | null;
    watermarkValue: string | null;
    backfillMinimum: string | null;
    tenantScheduleId: number | null;
    scheduleDescription: string | null;
    hasSched: boolean;
    source: string;
    notes: string;
    // used to alternate row color in the grid by parity (even/odd)
    rowGroupOrdinal: number;
    entityId: number | null;
    entityName: string | null;
    priority: string | null;
}

export interface ValidatableSelectableJob extends SelectableJob {
    valid: boolean;
}

export interface JobValidityState {
    ingestionId: number;
    valid: boolean;
}

export const defaultSelectJobGridColumns: AvailableDataColumn<SelectableJob>[] = [
    new AvailableDataColumn({
        name: 'entityName',
        title: 'Entity',
        iconClass: 'icon-table entity-ico',
        cellClass: e => (!e.entityId || e.entityId === -1 ? 'hc-font-em' : '')
    }),
    new AvailableDataColumn({ name: 'ingestMode', title: 'Ingest Mode' }),
    new AvailableDataColumn({
        name: 'priority',
        title: 'Priority',
        isShownByDefault: true,
        cellClass: e => (e.priority === 'HP' ? 'priority-indicator' : 'empty-cell')
    }),
    new AvailableDataColumn({ name: 'batchSize', title: 'Batch Size', isShownByDefault: false }),
    new AvailableDataColumn({ name: 'watermarkKey', title: 'Watermark Key', isShownByDefault: false }),
    new AvailableDataColumn({ name: 'watermarkValue', title: 'Watermark Value', isShownByDefault: false }),
    new AvailableDataColumn({ name: 'backfillMinimum', title: 'Backfill Minimum', isShownByDefault: false }),
    new AvailableDataColumn({
        name: 'scheduleDescription',
        title: 'Schedule',
        cellClass: e => (!e.hasSched ? 'cdp-empty-data-point' : '')
    }),
    new AvailableDataColumn({ name: 'notes', title: 'Notes', isShownByDefault: false }),
    new AvailableDataColumn({ name: 'source', title: 'Source', isShownByDefault: false }),
    new AvailableDataColumn({ name: 'activeFlag', title: 'Job State' })
];
